/**
 * @module utils/patterns
 * @description A collection of regex patterns
 */

/**
 * Matches only whole numbers
 * @type {RegExp}
 *
 * @example
 * '3'.match(eventOffsets) // ['3']
 * '3:00'.match(eventOffsets) // ['3']
 * 'a'.match(eventOffsets) // null
 */
export const eventOffsets: RegExp = /^\d+(?:\.\d{1,2})?$/;

/**
 * Regexp in string format that matches a duration up to 48 hours
 * @type {string}
 *
 * @example
 * '3:00'.match(durationUpTo48H) // ['3:00']
 * '49:00'.match(durationUpTo48H) // null
 */
export const durationUpTo48H: string =
    '^(?:[0-3]?\\d|4[0-7])(:(?:[30]0?))?$|^48(?::00)?$';

/**
 * - Regexp in string format that matches a date in the format MM/DD/YYYY or MM/DD/YYYY, ddd
 * @type {string}
 *
 * @example
 * '01/01/2020'.match(monthDayYear) // ['01/01/2020']
 * '01/01/2020, Mon'.match(monthDayYear) // ['01/01/2020, Mon']
 * '01/01/2020, Monday'.match(monthDayYear) // null
 */
export const monthDayYear: string =
    '(0?[1-9]|1[012])\\/(0?[1-9]|[12][0-9]|3[01])\\/(19|20)\\d\\d(,\\s\\w{3})?';

/**
 * - Regexp in string format that matches an email address
 * @type {string}
 *
 * @example
 * 'test@test.co'.match(email) // ['test@test.co']
 * 'test'.match(email) // null
 */
export const email: string =
    '^(([a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+(.[a-zA-Z0-9!#$%&’*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z-0-9]+\\.)+[a-zA-Z]{2,})$';

/**
 * Regexp that matches a dollar amount up to $1000 as well as an optional preceding $
 * @type {RegExp}
 *
 * @example
 * '$1000'.match(dollarAmountUpTo1000) // ['$1000']
 * '1000'.match(dollarAmountUpTo1000) // ['1000']
 * '1001'.match(dollarAmountUpTo1000) // null
 */
export const maxPriceTier: RegExp =
    /^\$?0*(?:1001|\d{1,3})(?:\.\d{0,2})?$|^\$$/;
